/* eslint-disable
    guard-for-in,
    no-restricted-syntax,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
angular.module('unergie.main')
.factory('ContractService', ($rootScope, AccountService) => {
    let contract = null
    const watchers = {}

    const update = function (contractUpdated) {
        if (contract !== contractUpdated) {
            contract = contractUpdated
            return (() => {
                const result = []
                for (const caller in watchers) {
                    const callback = watchers[caller]
                    result.push(callback(contract))
                }
                return result
            })()
        }
    }

    const watch = function (caller, callback) {
        watchers[caller] = callback
        if (contract) {
            return callback(contract)
        }
    }

    const reset = () => (contract = null)

    const updateCollection = function (collection) {
        if (watchers[collection]) {
            return watchers[collection](contract)
        }
    }

    const getContract = () => contract

    return {
        update,
        watch,
        reset,
        updateCollection,
        getContract,
    }
})
